module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 159
// module chunks = 0